exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/application/core-module/scora-modal-module/doc-pdf-modal-view/doc-pdf-modal-view.component.css
// module id = 842
// module chunks = 6